/* Rorilio · PDP Jabón de Caqui : galerie, choix du paquete (quantité 2/4/8 sur la variante unique), regalos débloqués, ATC avec regalos, comptes à rebours quotidiens (minuit heure de Mexico, quel que soit le visiteur, jusqu'à la fin du Black Friday), carrousel. Aucun effet hors des éléments data-rcq-*. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var MX_OFFSET = -6 * 3600 * 1000; // America/Mexico_City, UTC-6 toute l'année (pas d'heure d'été depuis 2022)
  var PROMO_END = Date.UTC(2026, 10, 28, 6, 0, 0); // 28 nov. 00:00 heure de Mexico = fin du Black Friday (27/11)
  function untilMidnight() {
    var now = Date.now(), mx = new Date(now + MX_OFFSET);
    var end = Date.UTC(mx.getUTCFullYear(), mx.getUTCMonth(), mx.getUTCDate() + 1) - MX_OFFSET;
    return Math.max(0, Math.floor((Math.min(end, PROMO_END) - now) / 1000));
  }
  function tickAll() {
    var s = untilMidnight(), h = pad(Math.floor(s / 3600)), m = pad(Math.floor((s % 3600) / 60)), sec = pad(s % 60);
    document.querySelectorAll('[data-rcq-countdown]').forEach(function (el) {
      var a = el.querySelector('[data-h]'), b = el.querySelector('[data-m]'), c = el.querySelector('[data-s]'), k = el.querySelector('[data-clock]');
      if (a) a.textContent = h; if (b) b.textContent = m; if (c) c.textContent = sec; if (k) k.textContent = h + ':' + m + ':' + sec;
    });
  }
  var ticking = false;
  function startClock() { if (ticking) return; ticking = true; tickAll(); setInterval(tickAll, 1000); }

  function initGallery(root) {
    var track = root.querySelector('[data-rcq-track]');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    var slides = track.children, thumbs = root.querySelectorAll('[data-rcq-thumb]');
    function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) { if (i < 0) i = slides.length - 1; if (i >= slides.length) i = 0; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function sync() {
      var i = cur();
      thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); if (on && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); } });
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.rcqThumb, 10)); }); });
    var prev = root.querySelector('[data-rcq-prev]'), next = root.querySelector('[data-rcq-next]');
    if (prev) prev.addEventListener('click', function () { go(cur() - 1); });
    if (next) next.addEventListener('click', function () { go(cur() + 1); });
  }

  function initOffer(root) {
    var offer = root.querySelector('[data-rcq-offer]');
    if (!offer || offer.dataset.ready) return;
    offer.dataset.ready = '1';
    var qty = root.querySelector('[data-rcq-qty]'), perbar = root.querySelector('[data-rcq-perbar]'), save = root.querySelector('[data-rcq-save]');
    function select(card) {
      offer.querySelectorAll('[data-rcq-pack]').forEach(function (c) { var on = c === card; c.classList.toggle('is-selected', on); var r = c.querySelector('input'); if (r) r.checked = on; });
      var q = parseInt(card.dataset.qty, 10) || 1;
      if (qty) qty.value = q;
      if (perbar && card.dataset.perbar) perbar.textContent = card.dataset.perbar;
      if (save) save.textContent = card.dataset.save || '';
      root.querySelectorAll('[data-rcq-gift]').forEach(function (g) { g.classList.toggle('is-unlocked', q >= (parseInt(g.dataset.min, 10) || 0)); });
    }
    offer.querySelectorAll('[data-rcq-pack]').forEach(function (card) {
      var r = card.querySelector('input');
      if (r) r.addEventListener('change', function () { if (r.checked) select(card); });
    });
  }

  function initForm(root) {
    var form = root.querySelector('[data-rcq-form]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    var btn = form.querySelector('[data-rcq-atc]'), err = form.querySelector('[data-rcq-error]');
    form.addEventListener('submit', function (e) {
      if (!window.RorilioCaqui) return; /* sans le script panier : envoi classique /cart/add */
      e.preventDefault();
      if (btn.disabled) return;
      var q = parseInt(form.querySelector('[data-rcq-qty]').value, 10) || 1;
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
      if (err) { err.hidden = true; err.textContent = ''; }
      window.RorilioCaqui.addPack(q).then(function (state) {
        if (!window.RorilioCaqui.open(state)) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }).catch(function (x) {
        if (err) { err.textContent = (x && x.message) || 'No se pudo agregar al carrito.'; err.hidden = false; }
      }).then(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
    });
  }

  function initScroller(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-rcq-scroller-track]');
    if (!track) return;
    var items = track.children;
    function step() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth; }
    function idx() { return Math.round(track.scrollLeft / Math.max(1, step())); }
    function go(i) { i = Math.max(0, Math.min(items.length - 1, i)); track.scrollTo({ left: i * step(), behavior: 'smooth' }); }
    var p = root.querySelector('[data-rcq-scroller-prev]'), n = root.querySelector('[data-rcq-scroller-next]');
    if (p) p.addEventListener('click', function () { go(idx() - 1); });
    if (n) n.addEventListener('click', function () { go(idx() + 1); });
  }

  /* Colonne d'achat collante (bureau) : si elle est plus haute que l'écran, elle défile jusqu'à montrer son bas (bouton visible) puis reste collée, au lieu de cacher le bouton sous l'écran. */
  function initSticky(root) {
    var info = root.querySelector('.rcq-info');
    if (!info || info.dataset.sticky) return;
    info.dataset.sticky = '1';
    function fit() { var top = Math.min(16, window.innerHeight - info.offsetHeight - 16); info.style.setProperty('--rcq-sticky-top', top + 'px'); }
    fit();
    window.addEventListener('resize', fit);
    if (window.ResizeObserver) new ResizeObserver(fit).observe(info);
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-rcq-main]').forEach(function (r) { initGallery(r); initOffer(r); initForm(r); initSticky(r); });
    s.querySelectorAll('[data-rcq-scroller]').forEach(initScroller);
    if (document.querySelector('[data-rcq-countdown]')) startClock();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
